import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import { PageIds } from "../../PageIds";
import GoldSectionView from "./GoldSectionView";
import RubySectionView from "./RubySectionView";
import OreSectionView from "./OreSectionView";
import PrestigeSectionView from "./PrestigeSectionView";

export default class CurrencyContainerView extends ParentView {
    /**
     * @param {string} parentId
     * @param {Totals} totals 
     */
    constructor(parentId, totals) {
        super(parentId, PageIds.CURRENCY_VIEW);

        this.addView(new OreSectionView(this.elementId, totals));
        this.addView(new GoldSectionView(this.elementId, totals));
        this.addView(new PrestigeSectionView(this.elementId, totals));
        this.addView(new RubySectionView(this.elementId, totals));

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        // <span id="currencyView" class="currency-container-view"></span>

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'currency-container-view');

        super.initializeView();        
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }
}